// Casino Providers
export enum PROVIDER_CASINO {
  EVOLUTION_GAMING = 'evolution',
  HIT_CLUB = 'hitclub',
  RIK_VIP = 'rikvip',
  B52 = 'b52',
  VIVO_GAMING = 'vivo-gaming',
  EBET = 'ebet',
  EZUGI = 'ezugi',
  DREAM_GAMING = 'dream-gaming',
  HO_GAMING = 'hogaming',
  YEE_BET = 'yeebet',
  PRAGMATIC = 'pragmatic'
}
